import React, { useLayoutEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome, FaFileAlt, FaAddressBook, FaCalendarAlt, FaFileExport, FaCog, FaTools, FaSignOutAlt, FaBars } from 'react-icons/fa';
import './SiteNav.css';

const links = [
  ['/', 'Home', FaHome],
  ['/schede', 'Pratiche', FaFileAlt],
  ['/contatti', 'Contatti', FaAddressBook],
  ['/agenda', 'Agenda', FaCalendarAlt],
  ['/esportazioni', 'Esportazioni', FaFileExport],
  ['/strumenti', 'Strumenti', FaTools],
  ['/impostazioni', 'Impostazioni', FaCog],
];

export default function SiteNav({ operator, onLogout, onNavigate, onToggleSections, sectionsOpen }) {
  const navRef = useRef(null);
  const [compact, setCompact] = useState(false);
  useLayoutEffect(() => {
    const nav = navRef.current;
    const update = () => {
      const items = [...nav.querySelectorAll('.site-nav-link')];
      // Measure labels even when visually hidden, so resizing can restore them.
      const required = items.reduce((width, item) => width + item.querySelector('span').scrollWidth + 16 + 8 + 24, 0) + (items.length - 1) * 8 + 32;
      setCompact(nav.clientWidth < Math.ceil(required));
    };
    const observer = new ResizeObserver(update);
    observer.observe(nav);
    nav.querySelectorAll('.site-nav-link span').forEach(label => observer.observe(label));
    update();
    document.fonts?.ready.then(update);
    return () => observer.disconnect();
  }, []);
  return <nav ref={navRef} className={`site-nav${compact ? ' site-nav-compact' : ''}`} aria-label="Navigazione principale">
    {onToggleSections && <button type="button" className="site-nav-sections" aria-label={sectionsOpen ? 'Chiudi schede della pratica' : 'Apri schede della pratica'} title="Schede della pratica" aria-expanded={sectionsOpen} onClick={onToggleSections}><FaBars aria-hidden="true" /></button>}
    {links.map(([path, label, Icon]) =>
      <NavLink key={path} to={path} aria-label={label} title={label} onClick={event => onNavigate?.(event, path)} end={path === '/'} className={({ isActive }) => `site-nav-link${isActive ? ' active' : ''}`}>
        <Icon aria-hidden="true" /> <span>{label}</span>
      </NavLink>
    )}
    <button type="button" className="site-nav-link site-nav-logout" aria-label="Esci" onClick={onLogout} title={`Esci — ${operator?.nome || operator?.username || "operatore"}`}><FaSignOutAlt aria-hidden="true" /><span>Esci</span></button>
  </nav>;
}
